(function ($) {

    /**
     * Ajax remove product
     */
    $(document).on('click', '[data-ajax-remove-product]', function (e) {
        e.preventDefault();

        var $element = $(this);
        var $product = $element.closest('[data-product]');

        // $('#product-' + $product.data('index')).remove();

        $.ajax({
            method: 'post',
            data: {
                do: 'removeProduct',
                index: $product.data('index')
            }
        }).done(function () {
            location.href = location;
        });
    });

    /**
     * Ajax add/remove additional item
     */
    $(document).on('change', '[data-additional-item-checkbox]', function (e) {
        var $element = $(this);
        var $product = $element.closest('[data-product]');

        $.ajax({
            method: 'post',
            data: {
                do: $element.prop('checked') ? 'addAdditionalProductItem' : 'removeAdditionalProductItem',
                index: $product.data('index'),
                id: $element.val()
            }
        });

        recountColors($product);
    });

    $(document).on('change', '[data-other-color-count],[data-id="other"]', function (e) {
        var $product = $(this).closest('[data-product]');
        var count = 0;

        if ($product.find('[data-id="other"]').prop('checked')) {
            count = $product.find('[data-other-color-count]').val();
        }

        $.ajax({
            method: 'post',
            data: {
                do: 'setOtherColors',
                index: $product.data('index'),
                count: count
            }
        });

        recountColors($product);
    });

    /**
     * Ajax add/remove color
     */
    $(document).on('change', '[data-color-checkbox]', function (e) {
        var $element = $(this);
        var $product = $element.closest('[data-product]');

        $.ajax({
            method: 'post',
            data: {
                do: $element.prop('checked') ? 'addColor' : 'removeColor',
                index: $product.data('index'),
                id: $element.val()
            }
        });
    });

    /**
     * Ajax set amount
     */
    $(document).on('change', '[data-product-amount]', function (e) {
        var $element = $(this);
        var $product = $element.closest('[data-product]');

        $.ajax({
            method: 'post',
            data: {
                do: 'setAmount',
                index: $product.data('index'),
                value: $element.val()
            }
        });
    });

    /**
     * Ajax set product format
     */
    $(document).on('change', '[data-product-format]', function (e) {
        var $element = $(this);
        var $product = $element.closest('[data-product]');

        $.ajax({
            method: 'post',
            data: {
                do: 'setFormat',
                index: $product.data('index'),
                value: $element.val()
            }
        });
    });

    /**
     * Ajax set textil color
     */
    $(document).on('change', '[data-product-textil-color]', function (e) {
        var $element = $(this);
        var $product = $element.closest('[data-product]');

        $.ajax({
            method: 'post',
            data: {
                do: 'setTextilColor',
                index: $product.data('index'),
                value: $element.val()
            }
        });
    });

    /**
     * Ajax set textil color
     */
    $(document).on('change', '[data-product-note]', function (e) {
        var $element = $(this);
        var $product = $element.closest('[data-product]');

        $.ajax({
            method: 'post',
            data: {
                do: 'setNote',
                index: $product.data('index'),
                value: $element.val()
            }
        });
    });

    $(document).on('click', '[data-next-step]', function (e) {
        e.preventDefault();
        $('<input type="submit">').hide().appendTo($('#basketForm')).click().remove();
    });

    $(document).on('change', '[name="billing[dic]"]', function (e) {
        var $element = $(this);
        $element[0].setCustomValidity("");

        if ($element.val()) {
            $.ajax({
                method: 'post',
                data: {
                    do: 'validateVat',
                    value: $element.val()
                }
            }).done(function (valid) {
                if (!valid) {
                    $element[0].setCustomValidity("Neplatné DIČ");
                }
            });
        }
    });
})(jQuery);